import { Separator } from '@/components/ui/separator';
import type { UserRole } from '@/entities/admin-user.entity';
import { useState } from 'react';
import UsersHeader from './header';
import UsersList from './users-list';

export default function AdminUsersPage() {
	const [search, setSearch] = useState('');
	const [role, setRole] = useState<UserRole | 'all'>('all');

	return (
		<main className='h-full min-h-0 flex flex-col gap-3 overflow-hidden p-2'>
			<div className='shrink-0'>
				<UsersHeader search={search} onSearchChange={setSearch} role={role} onRoleChange={setRole} />
			</div>
			<Separator className='shrink-0' />
			<div className='flex-1 basis-0 min-h-0'>
				<UsersList search={search} role={role} />
			</div>
		</main>
	);
}
